import { ChatRole, type ICharacter, type IConversationMessage } from "@next-platform/client-common-core";

type ChooseCharacterFromMessageOptions = {
  readonly message: IConversationMessage;
  /** The chat's character; in a group chat, the one whose sub-characters the messages speak as. */
  readonly character: ICharacter;
};

/**
 * The character a message speaks as. In a group chat that is the sub-character the message names; a user
 * message, a message naming nobody, and every message of a single-character chat speak as the chat's own.
 */
export default function chooseCharacterFromMessage({ message, character }: ChooseCharacterFromMessageOptions): ICharacter {
  const subCharacters = character?.sub_characters;
  if (!message?.character_id || !subCharacters || subCharacters.length === 0 || message.role === ChatRole.USER) {
    return character;
  }
  const subCharacter = subCharacters.find((candidate) => candidate.id === message.character_id);
  // A new copy on purpose: a bubble sets its character into state, and a fresh identity is what re-renders it.
  return subCharacter ? { ...subCharacter } : character;
}
